<!-- Error message info code -->
<div class="err-message"  fxLayout>
    <mat-icon>error_outline</mat-icon>
    <p>Error loading Data!</p>
  </div>